import APARTMENTS_POINTS from './apartments_points.geojson';
import HOUSTON_NEIGHBORHOODS from './houston_super_neighborhoods_official.geojson';
import SCHOOL_DISTRICTS from './metro_tx_school_districts_labeled_corrected.geojson';
import NEIGHBORHOODS_MERGED from './neighborhoods_merged.geojson';
import SCHOOLS_POINTS from './tx_schools_2024_2025.geojson';

export const APTS = APARTMENTS_POINTS;
export const NEIGHBORHOODS = NEIGHBORHOODS_MERGED;
export const HOUSTON_DATA = HOUSTON_NEIGHBORHOODS;
export const SCHOOL_DISTRICTS_DATA = SCHOOL_DISTRICTS;
export const SCHOOLS_DATA = SCHOOLS_POINTS;
